export default __webpack_public_path__ + "assets/apple-touch-icon-98x98-bdff672.png";